import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    messages: {
      conversationId: false,
      selectIds: [],
      filters: {},
      paginate: {}
    }
  },
  mutations: {
    SET_MESSAGE_CONVERSATION_ID (store, id) {
      store.messages.conversationId = id
    },
    SET_MESSAGE_SELECT_IDS (store, ids) {
      store.messages.selectIds = ids
    },
    ADD_MESSAGE_SELECT_IDS (store, ids) {
      const merged = store.messages.selectIds.slice()
      ids.forEach((id) => {
        if (!merged.includes(id)) {
          merged.push(id)
        }
      })
      store.messages.selectIds = merged
    },
    SET_MESSAGE_FILTERS (store, filters) {
      store.messages.filters = filters
    },
    SET_MESSAGE_PAGINATE (store, val) {
      store.messages.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    // messages of the selected conversation, sorted ascending (oldest first)
    getMessages: (store, getters) => {
      return store.messages.selectIds
      .map((id) => { return getters['entities/messages/find'](id) })
      .filter((message) => { return !!message })
      .sort((a, b) => {
        return new Date(a.sent_at || a.created_at) - new Date(b.sent_at || b.created_at)
      })
    },
    getMessagesConversationId: (store, getters) => {
      return store.messages.conversationId
    },
    getMessagesPaginate: (store, getters) => {
      return store.messages.paginate
    }
  },
  actions: {
    /*
    selectMessages
    loads (and replaces) the messages of a conversation
    */
    selectMessages ({commit, dispatch, getters, state}, {conversationId, filters}) {
      return dispatch('getMessages', { conversationId: conversationId, filters: { ...filters, abortid: 'select-messages' } })
      .then((response) => {
        commit('SET_MESSAGE_CONVERSATION_ID', conversationId)
        commit('SET_MESSAGE_FILTERS', filters || {})
        commit('SET_MESSAGE_PAGINATE', response)
        commit('SET_MESSAGE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    loadMoreMessages
    loads an older page keeping the current messages (history on scroll up)
    */
    loadMoreMessages ({commit, dispatch, getters, state}, page) {
      const conversationId = getters.getMessagesConversationId
      const filters = { ...state.messages.filters, page: page }
      return dispatch('getMessages', { conversationId: conversationId, filters: filters })
      .then((response) => {
        commit('SET_MESSAGE_FILTERS', filters)
        commit('SET_MESSAGE_PAGINATE', response)
        commit('ADD_MESSAGE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    getMessages
    */
    getMessages ({commit, dispatch, getters, state}, {conversationId, filters}) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/messaging/conversations/${conversationId}/messages`, {params: filters})
      .then((response) => {
        return dispatch('entities/messages/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.messages || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    sendMessage
    sends a message (text or template) to the conversation and stores the outbound
    */
    sendMessage ({commit, dispatch, getters, state}, {conversationId, data}) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/messaging/conversations/${conversationId}/messages`, data)
      .then((response) => {
        return dispatch('entities/messages/insert', {
          data: response.data
        })
      })
      .then((result) => {
        const message = result.messages[0]
        if (getters.getMessagesConversationId === conversationId) {
          commit('ADD_MESSAGE_SELECT_IDS', [message._id])
        }
        return message
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/messagingMessages.js